import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { useAuth } from "@/contexts/auth"
import { useNavigate } from "react-router-dom"
import { UserRole } from "@/types"
import { UserRole as UserRoleEnum } from "@/types/enums"
import { useState } from "react"
import { ChangePasswordModal } from "@/components/auth/ChangePasswordModal"

export function UserDropdown() {
  const { user, logout, switchRole } = useAuth()
  const navigate = useNavigate()
  const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false)

  const handleLogout = async () => {
    await logout()
    navigate("/login")
  }

  if (!user) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="h-8 w-8 rounded-full">
          <Avatar className="h-8 w-8">
            <AvatarImage src={user?.avatar} alt={user?.name} />
            <AvatarFallback>{user?.name?.slice(0, 2).toUpperCase()}</AvatarFallback>
          </Avatar>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end" forceMount>
        <DropdownMenuItem className="cursor-default">
          <div className="flex flex-col space-y-1">
            <span className="text-sm font-medium leading-none">{user.name}</span>
            <span className="text-xs leading-none text-muted-foreground">
              {user.email}
            </span>
            <span className="text-xs leading-none text-muted-foreground mt-1">
              Role: {user.role}
            </span>
          </div>
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        {user.role === UserRoleEnum.APP_OWNER && (
          <>
            <DropdownMenuItem onClick={() => navigate("/companies")}>
              Manage Companies
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => switchRole(UserRoleEnum.SUPER_ADMIN as UserRole)}>
              Switch to Super Admin
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => switchRole(UserRoleEnum.HR as UserRole)}>
              Switch to HR
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => switchRole(UserRoleEnum.DEPARTMENT_HEAD as UserRole)}>
              Switch to Department Head
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => switchRole(UserRoleEnum.PLANT_MANAGER as UserRole)}>
              Switch to Plant Manager
            </DropdownMenuItem>
            <DropdownMenuSeparator />
          </>
        )}
        <DropdownMenuItem onClick={() => setIsChangePasswordOpen(true)}>
          Change Password
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => navigate("/settings")}>Settings</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={handleLogout}>Logout</DropdownMenuItem>
      </DropdownMenuContent>
      
      <ChangePasswordModal
        isOpen={isChangePasswordOpen}
        onClose={() => setIsChangePasswordOpen(false)}
      />
    </DropdownMenu>
  )
}
